import React from 'react'
import { bind } from '@src/utils'
import Main from '@src/components/main'
import SearchBar from '@src/components/search-bar'
import Table from '@src/components/table'
import * as ReactIcons from '@src/lib/react-icons'
import { titleMap, headerMap, fieldOrderMap } from './config'
import { SettingViewModel, ISettingViewModel } from './setting.view-model'
import './style.scss'

function Setting({
  category,
  keyword,
  currentPage,
  itemList,
  handleNextOnClick,
  handlePrevOnClick,
  handleMoveToOnClick,
  handleKeywordOnChange,
  handleSearchClick,
  handleAddBtnOnClick,
  handleEditBtnOnClick,
  handleDelBtnOnClick
}: ISettingViewModel) {
  const title = titleMap[category]
  return (
    <Main pageTitle={title}>
      <div className='setting'>
        <div className='search-bar-wrap'>
          <SearchBar
            value={keyword}
            handleOnChange={handleKeywordOnChange}
            handleOnClick={handleSearchClick}
          />
          <button className='plus-btn' onClick={handleAddBtnOnClick}>
            <ReactIcons.FaPlus className='plus-icon' />
            <span>新增</span>
          </button>
        </div>
        {
          itemList && <Table
            header={headerMap[category]}
            fieldOrder={fieldOrderMap[category]}
            data={itemList.data}
            totalNumber={itemList.totalNumber}
            totalPages={itemList.totalPages}
            currentPage={currentPage}
            prevOnClick={handlePrevOnClick}
            nextOnClick={handleNextOnClick}
            moveToOnClick={handleMoveToOnClick}
            editOnClick={handleEditBtnOnClick}
            delOnClick={handleDelBtnOnClick}
          />
        }
      </div>
    </Main>
  )
}

export default bind(Setting, SettingViewModel)
